import { Container, Grid } from 'components/box';
import ProductListing from 'components/_shared/widgets/product-listing';
import Banner from 'components/_pages/home/banner';
import { ShopPageInterface } from './types';

const ShopPage = ({ banner, ...props }: ShopPageInterface) => (
  <Container py={[3, null, 3]}>
    <Grid>
      {banner && <Banner banners={banner} />}
      <ProductListing {...props} />
    </Grid>
  </Container>
);

export default ShopPage;
